import { memo } from 'react';

import { useWorkflowSessionSubscriptions } from './hooks/useWorkflowSessionSubscriptions';

const WorkflowSessionSubscriptionsComponent = () => {
  useWorkflowSessionSubscriptions();

  return null;
};

export const WorkflowSessionSubscriptions = memo(
  WorkflowSessionSubscriptionsComponent,
);
